import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialMonitoringDocumentState: Dtos.MonitoringDocument & IRegistrationFormState = {
    id: null,
    monitoringId: null,
    monitoring: null,
    name: null,
    location: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IMonitoringDocumentReduxFormState {
    id: IFieldState<number>,
    monitoringId: IFieldState<number>,
    monitoring: IFieldState<Dtos.Monitoring>,
    name: IFieldState<string>,
    location: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>,
}
